<div class="header d-flex justify-content-between align-content-around">
  <div class="all-venues" nbTooltip="All zones" (click)="activeZone('#all$')" [ngClass]="{ active: isZone('#all$') }">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          d="M9.28889 0H0.814815C0.366667 0 0 0.366667 0 0.814815V9.28889C0 9.73704 0.366667 10.1037 0.814815 10.1037H9.28889C9.73704 10.1037 10.1037 9.73704 10.1037 9.28889V0.814815C10.1037 0.366667 9.73704 0 9.28889 0ZM8.47407 8.47407H1.62963V1.62963H8.47407V8.47407Z"
          fill="#8F9BB3"
        />
        <path
          d="M21.1854 0H12.7113C12.2632 0 11.8965 0.366667 11.8965 0.814815V9.28889C11.8965 9.73704 12.2632 10.1037 12.7113 10.1037H21.1854C21.6335 10.1037 22.0002 9.73704 22.0002 9.28889V0.814815C22.0002 0.366667 21.6335 0 21.1854 0ZM20.3706 8.47407H13.5261V1.62963H20.3706V8.47407Z"
          fill="#8F9BB3"
        />
        <path
          d="M9.28889 11.8965H0.814815C0.366667 11.8965 0 12.2632 0 12.7113V21.1854C0 21.6335 0.366667 22.0002 0.814815 22.0002H9.28889C9.73704 22.0002 10.1037 21.6335 10.1037 21.1854V12.7113C10.1037 12.2632 9.73704 11.8965 9.28889 11.8965ZM8.47407 20.3706H1.62963V13.5261H8.47407V20.3706Z"
          fill="#8F9BB3"
        />
        <path
          d="M21.1854 11.8965H12.7113C12.2632 11.8965 11.8965 12.2632 11.8965 12.7113V21.1854C11.8965 21.6335 12.2632 22.0002 12.7113 22.0002H21.1854C21.6335 22.0002 22.0002 21.6335 22.0002 21.1854V12.7113C22.0002 12.2632 21.6335 11.8965 21.1854 11.8965ZM20.3706 20.3706H13.5261V13.5261H20.3706V20.3706Z"
          fill="#8F9BB3"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="carousel">
    <ul class="venue-list">
      <li class="venue-list-item" [nbTooltip]="item.name" *ngFor="let item of zones" (click)="activeZone(item)" [ngClass]="{ active: isZone(item.slug) }">
        <div>{{ item.name }}</div>
      </li>
    </ul>
    <button class="previous" (click)="showPreviousZone()" [ngClass]="{ disabled: isFirstZoneViewed }"><mat-icon>arrow_back_ios_new</mat-icon></button>
    <button class="next" (click)="showNextZone()" [ngClass]="{ disabled: isLastZoneViewed }"><mat-icon>arrow_forward_ios</mat-icon></button>
  </div>
  <div class="d-flex align-items-center m-0 px-2" [ngClass]="{ 'show-pointer': status === false }" (click)="onReconnectClicked()">
    <img src="https://library.micetribe.com/icons/wifi.svg" alt="wifi" *ngIf="status" />
    <img src="https://library.micetribe.com/icons/no-wifi.svg" alt="no-wifi" *ngIf="status === null" />
    <mat-icon nbTooltip="Click to reconnect" class="text-primary show-pointer" *ngIf="status !== null && !status"> autorenew </mat-icon>
    <span class="pl-2">{{ status === null ? 'Disconnected' : status ? 'Connected' : 'Reconnect' }}</span>
  </div>
</div>
